import { DomElement, ViewStream } from "spyne";
import { PageDocItemsTraits } from "traits/page-doc-items-traits";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { PageDocsItemsExternalTraits } from "traits/page-docs-items-external-traits";
import { CodeSampleTraits } from "traits/code-sample-traits";
import { UtilTraits } from "traits/util-traits";
import hljs from "highlight.js";
import { PageDocsItemBlockCardCallout } from "components/pages/page-docs-item-block-card-callout";
//import javascript from 'highlight.js/lib/languages/javascript';
//hljs.registerLanguage('javascript', javascript);

export class PageDocsItemBlock extends ViewStream {
  constructor(props = {}) {
    props.traits = [PageDocsItemsExternalTraits, CodeSampleTraits];

/*    props.data["codeSampleIdClean"] = ["codeSample", "codeSampleBash"].includes(
      props.data.blockType,
    )
      ? UtilTraits.util$RemoveSpacesAndSpecialChars(props.data.codeSampleId)
      : undefined;*/
    //props.id = `${props.parentVsid}-${props.blockNum}-${props.data.blockType}`
    props.template = PageDocItemsTraits.pageDocItems$GetItemBlockTemplate(
      props.data.blockType,
    );
    const howOrWhyClass =
      props.data.isHowOrWhyUseIt === true ? "how-or-why" : "";
    const externalType = props.data.externalType
      ? "external-" + String(props.data.externalType).toLowerCase()
      : "";
    props.class = `docs-item-block docs-item-block-${props.data.blockType} page-${props.pageId} ${howOrWhyClass} ${externalType} ${props.data?.classVal} ${props.data.class ?? ""}`;

     //console.log('props item data ', props.data?.classVal,props.data);
    //console.log(" TMPL TYPE IS ",props.data.blockType,props.data);

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {

    return this.props.el$("a").exists ? [["a", "click"]] : [];

    // return nexted array(s)
  }

  static escapeHtml(text) {
    var map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };

    return text.replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  }

  onRendered() {
    if (["codeSample", "codeSampleBash"].includes(this.props.data.blockType)) {
      const { codeSampleId } = this.props.data;
      const codeEl = this.props.el$("code").el;
      const fn = this[codeSampleId];

      //console.log("CODE SAMPLE ID ",{codeSampleId, fn }, this.props);

      codeEl.innerHTML = this[codeSampleId]();
      //const contentStr = PageDocsItemBlock.escapeHtml(codeEl.innerHTML);

      //console.log("CONTENT STR IS ",contentStr)
      const onHighlight = () => hljs.highlightElement(codeEl);
      requestAnimationFrame(onHighlight);
      //window.setTimeout(onHighlight, 1000);
    }

    if (this.props.data.blockType === "introCallout") {
      this.appendView(
        new PageDocsItemBlockCardCallout({ data: this.props.data }),
      );
    }

    if (this.props.data.blockType === "external") {
      this.pageDocsExternals$AddExternalItem();
      PageLoadDocsTraits.pageLoad$HideEmptyEl(this.props);
    } else if (this.props.data.blockType === "znutshell") {
      this.props.el.append(
        new DomElement({
          tagName: "pre",
          class: "theme-atom-one-light language-javascript",
          template: `<code class="theme-atom-one-light language-javascript">
             const helloWorld = new ViewStream({
                style:   "font-family:sans-serif;",
                data:    "Hello World"
             });
             
          
              const worldImage = new ViewStream({
                tagName: "img",
                width:   "350px",
                src:     "https://holdrr.com/s/moon.jpg"
              })
          
              helloWorld.appendToDom(document.body);
              helloWorld.appendView(worldImage);
                </code>
               `,
        }).render(),
      );
    }

    //console.log("ALL ELS ",this.props.el$('.bash-theme pre code').el)

    //hljs.highlightAll(this.props.el$('.bash-theme pre code').el, {language: 'bash', theme: "atom-one-light"});
    const testEl = this.props.el$(
      '.bash-theme pre code:not([data-highlighted="yes"])',
    );

    if (testEl.exists) {
      hljs.highlightAll(testEl.el, {
        language: "bash",
        theme: "atom-one-light",
      });
    }
  }
}
